import { getAccessToken } from "../utils/storage";
import { AxiosResponse } from "axios";

import Axios from "../utils/http-request";
import { PostApiProp, RepresentativeApiProp } from "../interface/api";
import { NewsfeedProps } from "../interface/newsfeed";
import { RepresentativeDataList } from "../interface/representative";

// export const apiGetNewsfeed = async (pagination: {page: number, page_size: number}) => {
//   // Get access token
//   const { accessToken, tokenType } = await getAccessToken();
//   try {
//     const uri = `/feeds?page=${pagination.page}&page_size=${pagination.page_size}`;

//     // Get request configuration (assuming this function provides headers, etc.)
//     const cfg = {
//       headers: {
//         Authorization: `${tokenType} ${accessToken}`,
//       },
//     };

//     // Send the GET request
//     const result = await Axios.get(uri, cfg);

//     // Return the result
//     return result;
//   } catch (e: any) {
//     console.error(e);

//     // Return error response
//     return {
//       data: {},
//       status: "error",
//       details: e?.response?.data?.details || e?.details,
//     };
//   }
// };

// Successful response type

interface MetaData {
  current_page: number;
  last_page: number;
}

interface APIResponse<T> {
  data: T[];
  meta: MetaData;
}

interface PaginationParams {
    page: number;
    search: string;
    page_size: number;
    state: string;
    local_government: string;
    position: string;
    sort_by: string;
    sort_order: string;
  }
export const apiGetRepresentativeList = async (
  pagination: PaginationParams
): Promise<{ data: APIResponse<RepresentativeDataList> }> => {
  const { accessToken, tokenType } = await getAccessToken();
  
  const uri = `/accounts/representatives?position=${pagination.position}&search=${pagination?.search}&state=${pagination.state}&local_government=${pagination.local_government}&page=${pagination.page}&page_size=${pagination.page_size}`;
  const cfg = {
    headers: {
      Authorization: `${tokenType} ${accessToken}`,
    },
  };

  try {
    const result = await Axios.get<APIResponse<RepresentativeDataList>>(uri, cfg);
    return { data: result.data }; // Successful response
  } catch (e: any) {
    console.error(e);
    // Return a consistent error shape
    return {
      data: {
        data: [],
        meta: { current_page: pagination.page, last_page: pagination.page },
      },
    };
  }
};

export const apiGetRepresentative = async (values: RepresentativeApiProp) => {
    const { accessToken, tokenType } = await getAccessToken();
    try {
      const uri = `/accounts/representatives?search=${values?.search}&state=${values.state}&local_government=${values.local_government}&position=${values.position}&sort_by=${values.sort_by}&sort_order=${values.sort_order}&page=${values.page}&page_size=${values.page_size}`;
  
      // Get request configuration (assuming this function provides headers, etc.)
      const cfg = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${tokenType} ${accessToken}`,
        },
      };
  
      // Send the GET request
      const result = await Axios.get(uri, cfg);
  
      // Return the result
      return result;
    } catch (e: any) {
      console.error(e);
  
      // Return error response
      return {
        data: {},
        status: "error",
        details: e?.response?.data?.details || e?.details,
      };
    }
  };